import { render } from "./ImsiInventorySettings.vue?vue&type=template&id=97988df2"
import script from "./ImsiInventorySettings.vue?vue&type=script&lang=js"
export * from "./ImsiInventorySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__